export enum SystemMessage {
  UNKNOWN_ERROR = "Something's wrong",
}
